import React, { memo, useCallback } from 'react'
import OverlayModal from './OverlayModal'

export interface ConfirmDialogProps {
  open: boolean
  title: string
  content: React.ReactNode
  confirmText?: string
  cancelText?: string
  danger?: boolean
  loading?: boolean
  onConfirm: () => void | Promise<void>
  onCancel: () => void
}

export const ConfirmDialog = memo(function ConfirmDialog({
  open,
  title,
  content,
  confirmText = '确认',
  cancelText = '取消',
  danger = false,
  loading = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  const handleConfirm = useCallback(async () => {
    try {
      await onConfirm()
    } catch (error) {
      console.error('Confirm action failed:', error)
    }
  }, [onConfirm])

  return (
    <OverlayModal open={open} title={title} onClose={onCancel}>
      <div style={{
        padding: '16px 0',
        fontSize: '15px',
        color: '#374151',
        lineHeight: 1.6,
      }}>
        {typeof content === 'string' ? (
          <p style={{ margin: 0 }}>{content}</p>
        ) : (
          content
        )}
      </div>
      <div style={{
        display: 'flex',
        gap: '12px',
        marginTop: '8px',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}>
        <button
          type="button"
          onClick={onCancel}
          disabled={loading}
          style={{
            flex: 1,
            height: '48px',
            padding: '0 16px',
            fontSize: '16px',
            fontWeight: 500,
            color: '#374151',
            backgroundColor: '#f3f4f6',
            border: 'none',
            borderRadius: '12px',
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.6 : 1,
            transition: 'background-color 0.15s ease',
          }}
          onMouseEnter={(e) => {
            if (!loading) e.currentTarget.style.backgroundColor = '#e5e7eb'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#f3f4f6'
          }}
        >
          {cancelText}
        </button>
        <button
          type="button"
          onClick={handleConfirm}
          disabled={loading}
          style={{
            flex: 1,
            height: '48px',
            padding: '0 16px',
            fontSize: '16px',
            fontWeight: 600,
            color: danger ? '#ffffff' : '#ffffff',
            backgroundColor: danger ? '#dc2626' : '#3b82f6',
            border: 'none',
            borderRadius: '12px',
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.6 : 1,
            transition: 'background-color 0.15s ease',
          }}
          onMouseEnter={(e) => {
            if (!loading) {
              e.currentTarget.style.backgroundColor = danger ? '#b91c1c' : '#2563eb'
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = danger ? '#dc2626' : '#3b82f6'
          }}
        >
          {loading ? '处理中...' : confirmText}
        </button>
      </div>
    </OverlayModal>
  )
})

export default ConfirmDialog
